import {
    AuditOutlined,
    FundOutlined,
    PlusOutlined,
    SearchOutlined,
    SettingOutlined, UnorderedListOutlined,
    UploadOutlined,
    PhoneOutlined, CheckCircleOutlined
} from "@ant-design/icons";

export const IconHome = {
    SCRIVANIA: <FundOutlined/>,
    DEED_MANAGEMENT: <AuditOutlined />,
    SETTINGS: <SettingOutlined />,
    SEARCH: <SearchOutlined />,
    UPLOAD: <UploadOutlined />,
    ADD: <PlusOutlined />,
    CRUSCOTTO: <UnorderedListOutlined />,
    CALL_REPORT: <PhoneOutlined />,
    ACTIVITY: <CheckCircleOutlined />
}